import type { ConsentOverviewCell } from '@/api/consents/consentsApi.types';
import type { BadgeTone } from '@/components/ui/badge';

export type ConsentCellStatus = 'agreed' | 'declined' | 'withdrawn' | 'pending' | 'reacceptance';

export const CONSENT_STATUS_TONE: Record<ConsentCellStatus, BadgeTone> = {
  agreed: 'success',
  declined: 'danger',
  withdrawn: 'warning',
  pending: 'muted',
  reacceptance: 'warning',
};

export const CONSENT_STATUS_LABEL_KEY: Record<ConsentCellStatus, string> = {
  agreed: 'overview.status.agreed',
  declined: 'overview.status.declined',
  withdrawn: 'overview.status.withdrawn',
  pending: 'overview.status.pending',
  reacceptance: 'overview.status.reacceptance',
};

export function resolveConsentCellStatus(cell: ConsentOverviewCell): ConsentCellStatus {
  if (cell.needsReacceptance === true) {
    return 'reacceptance';
  }
  if (cell.decision === 'agreed') {
    return 'agreed';
  }
  if (cell.decision === 'declined') {
    return 'declined';
  }
  if (cell.decision === 'withdrawn') {
    return 'withdrawn';
  }
  return 'pending';
}
